import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReportTable from "../components/ReportTable";
import PageHeader from "../components/PageHeader";
import Pagination from "../components/Pagination";
import "../assets/css/shiftgroup.css";
import DateRangeFilter from "../components/DateRangeFilter";
import { createShiftGroup, shiftGroupListsApis, updateShiftGroup, deleteShiftGroup, checkDeleteShiftGroup, getShiftGroupById } from "../redux/shiftgroup/ShiftGroupActions";
import { selectShiftGroupData, selectShiftGroupStatus, selectShiftGroupMeta, selectShiftGroupById } from "../redux/shiftgroup/ShiftGroupSelector";
import { Row } from "jspdf-autotable";
import Loader from "../components/Loader";
import SkSelect from "../components/SkSelect";
// import { getShiftGroupById } from "../redux/shiftgroup/ShiftGroupApi";

const YES_NO_OPTIONS = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

const ACTIVE_STATUS_OPTIONS = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

const columns = [
  { key: "action", label: "Action" },
  // { key: "sno", label: "S.No" },
  { key: "shiftGroup", label: "Shift Group" },
  {
    key: "rotationGroup",
    label: "Rotation Group",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "1", label: "Yes" },
      { value: "0", label: "No" },
    ],
  },
  {
    key: "status",
    label: "Status",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "1", label: "Active" },
      { value: "0", label: "Inactive" },
    ],
  },
];

// const data = [
//   {
//     id: 1,
//     sno: 1,
//     shiftGroup: "GENERAL-1",
//     rotationGroup: "No",
//     status: "ACTIVE",
//   },
//   {
//     id: 2,
//     sno: 2,
//     shiftGroup: "ROTATION",
//     rotationGroup: "Yes",
//     status: "ACTIVE",
//   },
// ];

function ShiftGroup() {

  const dispatch = useDispatch();

  const shiftGroupData = useSelector(selectShiftGroupData);
  const shiftMeta = useSelector(selectShiftGroupMeta);
  const status = useSelector(selectShiftGroupStatus);
  const selectShiftGroup = useSelector(selectShiftGroupById);
  const [loading, setLoading] = useState(false);
  const [touched, setTouched] = useState({
    ShiftGroupName: false
  });
  const [editTouched, setEditTouched] = useState({
    ShiftGroupName: false
  })


  const FieldError = (field) =>
    touched[field] && errors[field] ? (
      <p className="error-text">{errors[field]}</p>
    ) : null;

  const editFieldError = (field) =>
    editTouched[field] && editErrors[field] ? (
      <p className="error-text">{editErrors[field]}</p>
    ) : null;

  // Server-side filter params sent to list-shiftgroup
  // (0 = All, 1 = Yes/Active, 2 = No/Inactive)
  const [filters, setFilters] = useState({
    ShiftGroupName: "",
    Rotation: "",
    Status: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);


  // Map the table's header filter inputs to the API params.
  // Each entry is { op, value } (text) or { value } (select).
  const handleHeaderFilterChange = useCallback((cf) => {

    const updatedFilters = {};

    if (cf.shiftGroup?.value) {
      updatedFilters.ShiftGroupName = cf.shiftGroup.value;
    }

    if (
      cf.rotationGroup?.value !== undefined &&
      cf.rotationGroup?.value !== ""
    ) {
      updatedFilters.Rotation = Number(cf.rotationGroup.value);
    }

    if (
      cf.status?.value !== undefined &&
      cf.status?.value !== ""
    ) {
      updatedFilters.Status = Number(cf.status.value);
    }


    setFilters(updatedFilters);
    setCurrentPage(1);

  }, []);

  // Build the list payload: undefined when nothing is filtered (no query params),
  // otherwise all three params.
  // const buildFilterPayload = useCallback(() => {

  //   const hasFilter =
  //     filters.ShiftGroupName.trim() !== "" ||
  //     filters.Rotation !== 0 ||
  //     filters.Status !== 0;

  //   return hasFilter
  //     ? {
  //         ShiftGroupName: filters.ShiftGroupName.trim(),
  //         Rotation: filters.Rotation,
  //         Status: filters.Status,
  //       }
  //     : undefined;
  // }, [filters]);
  const buildFilterPayload = useCallback(() => {

    const payload = {
      PageNumber: currentPage,
      PageSize: pageSize,
    };

    Object.keys(filters).forEach((key) => {

      const value = filters[key];

      if (value !== "" && value !== undefined && value !== null) {

        // if(typeof value === "string"){
        //   payload[key] = value.trim();
        // }
        // else{
        //   payload[key] = value;
        // }

        payload[key] = typeof value === "string" ? value.trim() : value;

      }


    });



    return payload;

  }, [filters, currentPage, pageSize]);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [hasChildren, setHasChildren] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState("");


  const [showModal, setShowModel] = useState(false);
  const [formData, setFormData] = useState({
    ShiftGroupCode: "",
    shiftGroupName: "",
    Rotation: false,
    Status: true,
  })

  const [showAddModal, setShowAddModal] = useState(false);
  const [addFormModal, setAddFormData] = useState({
    ShiftGroupName: "",
    Rotation: false,
    Status: true,
  })
  const [errors, setErrors] = useState({
    ShiftGroupName: "",
  });

  const [editErrors, setEditErrors] = useState({
    ShiftGroupName: "",
  });

  const validateShiftGroupName = (name) => {
    const value = name.trim();

    if (!value) {
      return "Shift Group Name is required.";
    }

    if (value.length < 3) {
      return "Shift Group Name must be at least 3 characters.";
    }

    if (value.length > 50) {
      return "Shift Group Name cannot exceed 50 characters.";
    }

    if (!/^[A-Za-z0-9 _-]+$/.test(value)) {
      return "Only letters, numbers, spaces, hyphens (-) and underscores (_) are allowed.";
    }

    return "";
  };



  const handleAddShift = async () => {
    setTouched({
      ShiftGroupName: true,
    })

    const error = validateShiftGroupName(addFormModal.ShiftGroupName);

    if (error) {
      setErrors({
        ShiftGroupName: error,
      });
      return;
    }

    setErrors({
      ShiftGroupName: "",
    });

    setLoading(true);

    await dispatch(createShiftGroup(addFormModal));

    setShowAddModal(false);

    await dispatch(shiftGroupListsApis(buildFilterPayload()));

    setAddFormData({
      ShiftGroupName: "",
      Rotation: false,
      Status: true,

    });


    setLoading(false);
  };
  const handleEdit = async (row) => {

    const result = await dispatch(
      getShiftGroupById({
        ShiftGroupCode: row.id,
      })

    )

    console.log("RESULT:", result);
    console.log("PAYLOAD:", result.payload);
    console.log("PAYLOAD.DATA:", result.payload?.data);

    if (getShiftGroupById.fulfilled.match(result)) {
      const data = result.payload.data.data[0];

      setFormData({
        ShiftGroupCode: data.ShiftGroupCode,
        shiftGroupName: data.ShiftGroupName?.trim() || "",
        Rotation: data.Rotation,
        Status: data.Status,
      });

      // Clear previous validation errors
      setEditErrors({
        ShiftGroupName: "",
      });

      setShowModel(true);
    };
  }
  const handleUpdate = async () => {
    setLoading(true);
    setEditTouched({
      ShiftGroupName: true,
    });


    console.log(formData.shiftGroupName);
    const error = validateShiftGroupName(formData.shiftGroupName);

    if (error) {
      setEditErrors({
        ShiftGroupName: error,
      });
      setLoading(false);
      return;
    }
    setEditErrors({
      ShiftGroupName: "",
    });

    await dispatch(updateShiftGroup(formData));

    await dispatch(shiftGroupListsApis(buildFilterPayload()));

    setShowModel(false);

    setLoading(false);
  };

  const handleDelete = async () => {
    setLoading(true)


    const result = await dispatch(
      deleteShiftGroup({
        ShiftGroupCode: selectedRow.id,
        force: hasChildren
      })
    );
    if (deleteShiftGroup.fulfilled.match(result)) {
      setShowDeleteModal(false)
      await dispatch(shiftGroupListsApis(buildFilterPayload()));
    }
    setLoading(false)

    // if(deleteShiftGroup.rejected.match(result)){
    //   if(
    //     result.payload && 
    //     result.payload.toLowerCase().includes("child")
    //   ){
    //     setdeleteWithChildren(true);
    //   }
    // }

  }
  const openDeletePopup = async (row) => {
    console.log("Delete Row:", row);
    setSelectedRow(row);
    const result = await dispatch(
      checkDeleteShiftGroup({
        ShiftGroupCode: row.id,
      })

    );
    if (checkDeleteShiftGroup.fulfilled.match(result)) {
      setDeleteMessage(result.payload.data.message);
      setHasChildren(result.payload.data.hasChildren);
      setShowDeleteModal(true)
    }
  }

  // Debounced fetch: re-runs whenever a filter changes (also loads on mount).
  // When no filter is active, send NO params (null) so the initial load matches
  // the original request; once a filter is set, send all three params.
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        await dispatch(shiftGroupListsApis(buildFilterPayload()));
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    const timer = setTimeout(fetchData, 400);

    return () => clearTimeout(timer);
  }, [dispatch, buildFilterPayload]);

  const data = shiftGroupData.map((item, index) => ({
    id: item.ShiftGroupCode,
    sno: index + 1,
    shiftGroup: item.ShiftGroupName?.toUpperCase() || "",
    rotationGroup: item.Rotation ? "YES" : "NO",
    status: (
      <button
        className={
          item.Status
            ? "status-btn active-status"
            : "status-btn inactive-status"
        }>
        {item.Status ? "ACTIVE" : "INACTIVE"}
      </button>
    )

  }));

  // if(loading || status === "loading") {
  //     {loading && <Loader />}
  // }

  return (
    <>
      {loading && <Loader isLoading={true} />}


      <div className="shiftgroup-page">
        <PageHeader
          icon={<i className="bi bi-collection"></i>}
          title="Shift Group"
          subtitle="Group shifts and manage rotation"
          actions={
            <>
              <button
                className="add-shift-btn"
                onClick={() => {
                  setAddFormData({
                    ShiftGroupName: "",
                    Rotation: false,
                    Status: true,
                  });
                  setTouched({
                    ...touched,
                    ShiftGroupName: true,
                  });

                  setErrors({
                    ShiftGroupName: "",
                  })
                  setShowAddModal(true);
                }}
              >
                + New
              </button>
            </>
          }
        />

        <div className="shift-data">
          <div className="table-container">
            <ReportTable
              columns={columns}
              data={data}
              serverSide={true}
              stickyColumns={["action"]}
              onHeaderFilterChange={handleHeaderFilterChange}
              renderActions={(row) => (
                <div className="shift-action-buttons">
                  <button className="action-btn edit-btn"
                    onClick={() => handleEdit(row)}>
                    <i className="bi bi-pencil-square"></i>
                  </button>
                  <button className="action-btn delete-btn"
                    onClick={() => {
                      openDeletePopup(row)
                    }}>
                    <i className="bi bi-trash-fill"></i>
                  </button>

                </div>

              )}

            />
          </div>

          <Pagination
            currentPage={currentPage}
            totalCount={shiftMeta?.totalRecords || 0}
            pageSize={pageSize}
            onPageChange={setCurrentPage}
            onPageSizeChange={(size) => {
              setPageSize(size);
              setCurrentPage(1);
            }}
          />
        </div>

        {showModal && (
          <div
            className="se-overlay"
            onClick={() => {
              setShowModel(false);

              setEditTouched({
                ShiftGroupName: false,
              });

              setEditErrors({
                ShiftGroupName: "",
              });
            }}  >
            <div
              className="se-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="se-modal__header">
                <div>
                  <h3>Edit Shift Group</h3>
                  <p className="se-modal__subtitle">
                    Update shift group details
                  </p>
                </div>

                <button
                  className="se-close"
                  onClick={() => setShowModel(false)}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>

              <div className="se-modal__body">

                <section className="se-section">

                  <h4 className="se-section__title">
                    Shift Group Details
                  </h4>

                  <div className="se-grid">

                    {/* Shift Group Name */}

                    <div className="se-field se-field--full">

                      <label>Shift Group Name</label>

                      <input
                        className={`se-input ${editErrors.ShiftGroupName
                            ? "se-input--error"
                            : ""
                          }`}
                        type="text"
                        value={formData.shiftGroupName}
                        onChange={(e) => {
                          const value = e.target.value;

                          setFormData({
                            ...formData,
                            shiftGroupName: e.target.value,
                          });
                          setEditTouched({
                            ShiftGroupName: true,
                          })

                          setEditErrors({
                            ShiftGroupName: validateShiftGroupName(value),
                          });
                        }}
                      />
                      {editFieldError("ShiftGroupName")}

                    </div>

                    {/* Rotation */}

                    <div className="se-field">

                      <label>Rotation</label>

                      <SkSelect
                        size="md"
                        width="100%"
                        value={formData.Rotation}
                        options={YES_NO_OPTIONS}
                        onChange={(value) =>
                          setFormData({ ...formData, Rotation: value })
                        }
                        ariaLabel="Rotation"
                      />

                    </div>

                    {/* Status */}

                    <div className="se-field">

                      <label>Status</label>

                      <SkSelect
                        size="md"
                        width="100%"
                        value={formData.Status}
                        options={ACTIVE_STATUS_OPTIONS}
                        onChange={(value) =>
                          setFormData({ ...formData, Status: value })
                        }
                        ariaLabel="Status"
                      />

                    </div>

                  </div>

                </section>

              </div>

              <div className="se-modal__footer">

                <button
                  className="se-btn se-btn--ghost"
                  onClick={() => setShowModel(false)}
                >
                  Cancel
                </button>

                <button
                  className="se-btn se-btn--primary"
                  onClick={handleUpdate}
                >
                  Update
                </button>

              </div>

            </div>
          </div>
        )}
        {showAddModal && (
          <div
            className="se-overlay"
            onClick={() => {
              setShowAddModal(false);

              setTouched({
                ShiftGroupName: false,
              });

              setErrors({
                ShiftGroupName: "",
              });
            }}  >
            <div
              className="se-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="se-modal__header">
                <div>
                  <h3>Add Shift Group</h3>
                  <p className="se-modal__subtitle">
                    Create a new shift group
                  </p>
                </div>

                <button
                  className="se-close"
                  onClick={() => setShowAddModal(false)}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>

              <div className="se-modal__body">

                <section className="se-section">

                  <h4 className="se-section__title">
                    Shift Group Details
                  </h4>

                  <div className="se-grid">

                    <div className="se-field se-field--full">

                      <label>Shift Group Name</label>

                      <input
                        className={`se-input ${errors.ShiftGroupName
                            ? "se-input--error"
                            : ""
                          }`}
                        type="text"
                        placeholder="Enter Shift Group Name"
                        value={addFormModal.ShiftGroupName}
                        onChange={(e) => {

                          const value = e.target.value;

                          setAddFormData({
                            ...addFormModal,
                            ShiftGroupName: e.target.value,
                          });

                          if (touched.ShiftGroupName) {
                            setErrors({
                              ShiftGroupName: validateShiftGroupName(value),
                            });
                          }
                        }}
                      />

                      {errors.ShiftGroupName && (
                        <p className="error-text">
                          {errors.ShiftGroupName}
                        </p>
                      )}

                    </div>

                    <div className="se-field">

                      <label>Rotation</label>

                      <SkSelect
                        size="md"
                        width="100%"
                        value={addFormModal.Rotation}
                        options={YES_NO_OPTIONS}
                        onChange={(value) =>
                          setAddFormData({ ...addFormModal, Rotation: value })
                        }
                        ariaLabel="Rotation"
                      />

                    </div>

                    <div className="se-field">

                      <label>Status</label>

                      <SkSelect
                        size="md"
                        width="100%"
                        value={addFormModal.Status}
                        options={ACTIVE_STATUS_OPTIONS}
                        onChange={(value) =>
                          setAddFormData({ ...addFormModal, Status: value })
                        }
                        ariaLabel="Status"
                      />

                    </div>

                  </div>

                </section>

              </div>

              <div className="se-modal__footer">

                <button
                  className="se-btn se-btn--ghost"
                  onClick={() => setShowAddModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="se-btn se-btn--primary"
                  onClick={handleAddShift}
                >
                  Save
                </button>

              </div>

            </div>
          </div>
        )}
        {showDeleteModal && (
          <div
            className="se-overlay"
            onClick={() => {
              setShowDeleteModal(false);
              setHasChildren(false);
              setDeleteMessage("");
            }}
          >
            <div
              className="se-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="se-modal__header">
                <div>
                  <h3>Delete Shift Group</h3>
                  <p className="se-modal__subtitle">
                    Confirm before deleting this shift group
                  </p>
                </div>

                <button
                  className="se-close"
                  onClick={() => {
                    setShowDeleteModal(false);
                    setHasChildren(false);
                    setDeleteMessage("");
                  }}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>

              <div className="se-modal__body">

                <section className="se-section">

                  <h4 className="se-section__title">
                    Confirmation
                  </h4>

                  <p
                    style={{
                      margin: 0,
                      color: "#475569",
                      lineHeight: "1.7",
                      fontSize: "15px",
                    }}
                  >
                    {deleteMessage}
                  </p>

                </section>

              </div>

              <div className="se-modal__footer">

                <button
                  className="se-btn se-btn--ghost"
                  onClick={() => {
                    setShowDeleteModal(false);
                    setHasChildren(false);
                    setDeleteMessage("");
                  }}
                >
                  Cancel
                </button>

                <button
                  className="se-btn se-btn--primary"
                  onClick={handleDelete}
                >
                  Delete
                </button>

              </div>

            </div>
          </div>
        )}
      </div>
    </>
  );
}



// 
export default ShiftGroup;